Object.defineProperty(exports, "__esModule", {
  value: true
});

var constants_1 = require("../constants");

function coalesce(current, fallback) {
  return current === constants_1._ ? fallback : current;
}

exports.coalesce = coalesce;